import sound1 from 'Static/Sounds/key1.mp3'
import sound2 from 'Static/Sounds/key2.mp3'
import sound3 from 'Static/Sounds/key3.mp3'
import sound4 from 'Static/Sounds/key4.mp3'
import sound5 from 'Static/Sounds/key5.mp3'
import sound6 from 'Static/Sounds/key6.mp3'
import sound7 from 'Static/Sounds/key7.mp3'
import mobile_sound1 from 'Static/Sounds/mobile_key1.mp3'
import mobile_sound2 from 'Static/Sounds/mobile_key2.mp3'
import mobile_sound3 from 'Static/Sounds/mobile_key3.mp3'
import mobile_sound4 from 'Static/Sounds/mobile_key4.mp3'
import mobile_sound5 from 'Static/Sounds/mobile_key5.mp3'
import mobile_sound6 from 'Static/Sounds/mobile_key6.mp3'
import mobile_sound7 from 'Static/Sounds/mobile_key7.mp3'
import {sleep} from './utils'
import THEME_URI from 'Static/Sounds/terminator-theme.mp3';
const themeAudio = new Audio(THEME_URI)
let isThemePlaying = false;
themeAudio.addEventListener('ended', () => {
  console.log('theme finished naturally')
  isThemePlaying = false;
})
themeAudio.addEventListener('error', (e) => {
  console.log('themePlayer error:', e)
  isThemePlaying = false;
})


export const keyStrokePlay = (isMuted = false) => {
  const brand = Math.round(Math.random()*6+1) // 1-7
  let file = ''
  switch (brand) {
    case 1:
      file = isMuted ? mobile_sound1 : sound1
      break
    case 2:
      file = isMuted ? mobile_sound2 : sound2
      break
    case 3:
      file = isMuted ? mobile_sound3 : sound3
      break
    case 4:
      file = isMuted ? mobile_sound4 : sound4
      break
    case 5:
      file = isMuted ? mobile_sound5 : sound5
      break
    case 6:
      file = isMuted ? mobile_sound6 : sound6
      break
    case 7:
      file = isMuted ? mobile_sound7 : sound7
      break
    default:
      file = sound1
  }
  const audio = new Audio(file)
  audio.currentTime= 0.7
  try {
    audio.play().then(r => {}).catch(e => {
      console.log('keyStrokePlay   error1:', e)
    })
  } catch (e) {
    console.log('keyStrokePlay   error2:', e)
  }
}


export const themeStart = async () => {
  try {
    if (themeAudio && isThemePlaying) {
      console.log('pausing theme (so can play anew)...')
      await sleep(100)
      themeAudio.pause()
      isThemePlaying = false
      await sleep(100)
    }

    console.log('starting theme...'+ THEME_URI.split('/').pop())
    themeAudio.play().then(r => {
      isThemePlaying = true;
    }).catch(e => {
      console.log('themePlayer   error1:', e)
    })
  } catch (e) {
    console.log('themePlayer   error2:', e)
  }
}

export const themeStop = async () => {
  try {
    if (isThemePlaying) {
      console.log('pausing theme...')
      await sleep(100)
      themeAudio.pause()
      isThemePlaying = false
      await sleep(100)
    }
  } catch (e) {
    console.log('themeStop   error:', e)
  }
}
